export { default as WishListProductSelector } from "./WishListProductSelector";
